import _classCallCheck from "/Users/clark/Documents/ERICK PROFESIONAL/Web Page/website/Fullsite/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/clark/Documents/ERICK PROFESIONAL/Web Page/website/Fullsite/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/clark/Documents/ERICK PROFESIONAL/Web Page/website/Fullsite/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/clark/Documents/ERICK PROFESIONAL/Web Page/website/Fullsite/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/clark/Documents/ERICK PROFESIONAL/Web Page/website/Fullsite/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/clark/Documents/ERICK PROFESIONAL/Web Page/website/Fullsite/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Children, Component, cloneElement } from 'react';
import anime from 'animejs';

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var _class, _temp2; //      


var MagicLineMenu = (_temp2 = _class = /*#__PURE__*/function (_Component) {
  _inherits(_class, _Component);

  var _super = _createSuper(_class);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    var b;

    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (b = _this = _super.call.apply(_super, [this].concat(a)), Object.defineProperty(_assertThisInitialized(_this), 'setMenuValues', {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: function value() {
        var _this$menuNode$getBou = _this.menuNode.getBoundingClientRect(),
            a = _this$menuNode$getBou.left,
            b = _this$menuNode$getBou.right,
            c = _this$menuNode$getBou.width;

        _this.menuValues = {
          left: a,
          right: b,
          width: c
        };
      }
    }), Object.defineProperty(_assertThisInitialized(_this), 'setItemValues', {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: function value() {
        _this.itemValues = Array.from(_this.menuNode.childNodes).slice(1).map(function (a) {
          // $FlowIgnore
          var _a$getBoundingClientR = a.getBoundingClientRect(),
              b = _a$getBoundingClientR.left,
              c = _a$getBoundingClientR.right,
              d = _a$getBoundingClientR.width;

          return {
            left: b,
            right: c,
            width: d
          };
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), 'setLineStyle', {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: function value() {
        var _this$menuValues = _this.menuValues,
            a = _this$menuValues.left,
            b = _this$menuValues.width,
            _this$itemValues$_thi = _this.itemValues[_this.props.active],
            c = _this$itemValues$_thi.left,
            d = _this$itemValues$_thi.width;
        _this.lineNode.style.transform = "translateX(".concat(c - a, "px) scaleX(").concat(d / b, ")");
      }
    }), Object.defineProperty(_assertThisInitialized(_this), 'animateLine', {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: function value(a, b, c, d, e) {
        var f = anime.timeline({
          targets: _this.lineNode,
          duration: _this.props.duration || 500,
          easing: _this.props.easing || 'linear'
        });
        f.add({
          translateX: [a, a],
          scaleX: [b, c]
        }).add({
          translateX: [a, d],
          scaleX: [c, e]
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), 'menuValues', {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: {
        left: 0,
        right: 0,
        width: 0
      }
    }), Object.defineProperty(_assertThisInitialized(_this), 'itemValues', {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: []
    }), b));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMenuValues(), this.setItemValues(), this.setLineStyle();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(a) {
      var _this$menuValues2 = this.menuValues,
          b = _this$menuValues2.left,
          c = _this$menuValues2.right,
          d = _this$menuValues2.width,
          _this$itemValues$this = this.itemValues[this.props.active],
          e = _this$itemValues$this.left,
          f = _this$itemValues$this.right,
          g = _this$itemValues$this.width,
          _this$itemValues$a$ac = this.itemValues[a.active],
          h = _this$itemValues$a$ac.left,
          i = _this$itemValues$a$ac.right,
          j = _this$itemValues$a$ac.width,
          k = g / d,
          l = j / d;

      if (a.active > this.props.active) {
        this.lineNode.style.transformOrigin = '0% 50% 0', this.animateLine(e - b, k, (i - e - j / 2) / d, h - b, l);
      }

      if (a.active < this.props.active) {
        this.lineNode.style.transformOrigin = '100% 50% 0', this.animateLine(f - c, k, (f - h - j / 2) / d, i - c, l);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          a = _this$props.children,
          b = _this$props.onItemClick,
          c = _this$props.menuStyle,
          d = _this$props.lineStyle,
          e = _this$props.menuClassName,
          f = _this$props.lineClassName,
          g = _this$props.lineHeight,
          h = _this$props.lineColor;
      return React.createElement('div', {
        ref: function ref(a) {
          a && (_this2.menuNode = a);
        },
        style: _extends({
          display: 'flex',
          position: 'relative'
        }, c),
        className: e
      }, React.createElement('div', {
        ref: function ref(a) {
          a && (_this2.lineNode = a);
        },
        style: _extends({
          position: 'absolute',
          height: 0,
          bottom: 0,
          left: 0,
          right: 0,
          transformOrigin: '0% 50% 0',
          borderBottom: "".concat(g || 1, "px solid ").concat(h || 'black')
        }, d),
        className: f
      }), Children.map(a, function (a, c) {
        return cloneElement(a, {
          onClick: function onClick() {
            return b(c);
          }
        });
      }));
    }
  }]);

  return _class;
}(Component), Object.defineProperty(_class, 'defaultProps', {
  configurable: !0,
  enumerable: !0,
  writable: !0,
  value: {
    active: 0
  }
}), _temp2);
export default MagicLineMenu;